import { render } from "./PlaylistHeader.vue?vue&type=template&id=48f35cfc"
import script from "./PlaylistHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistHeader.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Playlist/PlaylistHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48f35cfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48f35cfc', __exports__)) {
    api.reload('48f35cfc', __exports__)
  }
  
  module.hot.accept("./PlaylistHeader.vue?vue&type=template&id=48f35cfc", () => {
    api.rerender('48f35cfc', render)
  })

}


export default __exports__